import { queryOptions } from '@tanstack/react-query'

import { getOrgInfo, getPayoutFees } from '@/api/organization'

export const ORGANIZATION_INFO_QUERY = 'organization-info-query'

export const orgInfoQueryOptions = (orgId: string) =>
  queryOptions({
    queryKey: [ORGANIZATION_INFO_QUERY, orgId],
    queryFn: async () => {
      if (!orgId) return null
      const { data } = await getOrgInfo(orgId)
      return data
    },
    enabled: !!orgId,
  })

const GET_PAYOUT_FEE_QUERY = 'get-payout-fee-query'

export const orgFeesQueryOptions = (orgId: string) => {
  return queryOptions({
    queryKey: [GET_PAYOUT_FEE_QUERY, orgId],
    queryFn: async () => {
      if (!orgId) return null
      const { data } = await getPayoutFees(orgId)
      return data
    },
  })
}
